/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendContractCommandDto
 */
export interface SendContractCommandDto {
    /**
     * 
     * @type {string}
     * @memberof SendContractCommandDto
     */
    quoteId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendContractCommandDto
     */
    forced: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendContractCommandDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractCommandDto
     */
    email: string;
    /**
     * ID of the broker's bank account for commission payments
     * @type {string}
     * @memberof SendContractCommandDto
     */
    bankAccountId?: string | null;
}

/**
 * Check if a given object implements the SendContractCommandDto interface.
 */
export function instanceOfSendContractCommandDto(value: object): value is SendContractCommandDto {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('forced' in value) || value['forced'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SendContractCommandDtoFromJSON(json: any): SendContractCommandDto {
    return SendContractCommandDtoFromJSONTyped(json, false);
}

export function SendContractCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendContractCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteId': json['quoteId'],
        'forced': json['forced'],
        'fullName': json['fullName'],
        'email': json['email'],
        'bankAccountId': json['bankAccountId'] == null ? undefined : json['bankAccountId'],
    };
}

export function SendContractCommandDtoToJSON(json: any): SendContractCommandDto {
    return SendContractCommandDtoToJSONTyped(json, false);
}

export function SendContractCommandDtoToJSONTyped(value?: SendContractCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quoteId': value['quoteId'],
        'forced': value['forced'],
        'fullName': value['fullName'],
        'email': value['email'],
        'bankAccountId': value['bankAccountId'],
    };
}

